exports.checkAllStates = (array, stateString) => {
  const validStates = ["lagos", "rivers", "oyo"];
  if (!validStates.includes(stateString.toLowerCase())) {
    return false;
  }
  return array.every((obj) => obj.state === stateString.toLowerCase());
};
